import axios from "axios"
import { clienteInfo, getUsuario } from "utils/DatosUsuarioLocalStorag"

// Boletos fisicos de UNA COMPRA (cualquier metodo de pago). El backend exige sesion de
// personal (admin, super_admin, vendedores, vendedor_secundario) por eso va el token.
const BASE = "https://api.t-ickets.com/ms_login/api/v1/boletos_fisicos"
const headers = () => ({
    'Content-Type': 'application/json',
    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
    'Authorization': `Bearer ${getUsuario()}`,
})

// Sesion del usuario para las llamadas de administrador hechas con AxioBoleteria (que no la manda sola)
export const cabecerasSesion = () => ({ Authorization: `Bearer ${getUsuario()}` })

export const PERFILES_PERSONAL = ["admin", "super_admin", "vendedores", "vendedor_secundario"]
export const esPersonal = () => {
    try { return PERFILES_PERSONAL.includes(String(clienteInfo()?.perfil || "").trim().toLowerCase()) } catch (_e) { return false }
}

export const BoletosFisicosDeCompra = async (idCompra) => {
    const { data } = await axios.get(`${BASE}/compra/${idCompra}`, { headers: headers() })
    return data
}

// codigos: [{ codigo_barras, seccion?, id_localidades_items? }] -- sin id se asignan en orden
export const AsignarBoletosFisicosCompra = async (idCompra, codigos) => {
    const { data } = await axios.post(`${BASE}/asignar_compra`, { id_registraCompra: Number(idCompra), codigos }, { headers: headers() })
    return data
}

export const QuitarBoletoFisicoCompra = async (idCompra, idLocalidadesItems) => {
    const { data } = await axios.post(`${BASE}/quitar_compra`,
        { id_registraCompra: Number(idCompra), id_localidades_items: Number(idLocalidadesItems) }, { headers: headers() })
    return data
}

export const BuscarBoletoFisico = async (codigoEvento, codigo) => {
    const { data } = await axios.get(`${BASE}/buscar`, { headers: headers(), params: { codigoEvento, codigo_barras: codigo } })
    return data
}

/* Ids de los boletos (localidades_items) que se estan vendiendo -- mismo criterio que
   PagoRapido (utils/Querycomnet.js). Numerados (asientosList) + correlativos (sillascorre).
   Su cantidad es cuantos boletos fisicos se pueden entregar en la venta. */
export const asientosDeLaVenta = () => {
    try {
        const asientos = sessionStorage.getItem("asientosList") != null
            ? JSON.parse(sessionStorage.getItem("asientosList")).map(e => e.ids ?? e.idsilla ?? e.id_silla ?? null).filter(e => e != null)
            : []
        const correlativos = sessionStorage.getItem("sillascorre") != null ? JSON.parse(sessionStorage.getItem("sillascorre")) : []
        return [...asientos, ...correlativos]
    } catch (_e) {
        return []
    }
}

/* Asigna los codigos de una venta recien hecha respetando el orden de los asientos de la venta
   (codigo i -> asiento i, como ya validaban Modalefectivo/ModalReporte). Si el backend dice que un
   asiento no es de la compra, ese codigo se reintenta en el siguiente boleto libre. */
export const AsignarFisicosDeVenta = async (idCompra, codigos, secciones = {}, asientos = []) => {
    if (!idCompra || !codigos.length) return null
    const lista = codigos.map((c, i) => ({
        codigo_barras: c,
        ...(secciones[c] ? { seccion: secciones[c] } : {}),
        ...(asientos[i] ? { id_localidades_items: Number(asientos[i]) } : {}),
    }))
    const r = await AsignarBoletosFisicosCompra(idCompra, lista)
    const reintentar = (r?.resultados || []).filter(x => !x.ok && /no pertenece/i.test(x.message || ""))
    if (!reintentar.length) return r
    const r2 = await AsignarBoletosFisicosCompra(idCompra, reintentar.map(x => ({
        codigo_barras: x.codigo_barras, ...(secciones[x.codigo_barras] ? { seccion: secciones[x.codigo_barras] } : {}),
    })))
    const porCodigo = Object.fromEntries((r2?.resultados || []).map(x => [x.codigo_barras, x]))
    const resultados = (r?.resultados || []).map(x => porCodigo[x.codigo_barras] || x)
    const asignados = resultados.filter(x => x.ok).length
    return { success: asignados > 0, asignados, resultados }
}

// Texto corto con lo que no se pudo asignar (para un aviso)
export const resumenResultados = (r) => {
    const malos = (r?.resultados || []).filter(x => !x.ok)
    if (!malos.length) return ""
    return malos.map(x => `${x.codigo_barras || "?"}: ${x.message}`).join(" | ")
}

// Mover cortesias (sillas ocupadas sin compra) a sillas libres de la misma localidad. Solo admin. aplicar=false solo revisa
export const moverCortesias = async (pedido) => {
    const { data } = await axios.post(`${BASE}/mover_cortesias`, pedido, { headers: headers() })
    return data
}
